import { createSafeContext } from '@/package';

import type { ModelingListContextValue } from './type';

const ModelingListContext = createSafeContext<ModelingListContextValue>(
  null,
  'ModelingListContext',
);

export default ModelingListContext;
